import { isOutreachSuppressed, type OutreachRow } from '@discovr/types';

export const NO_EMAIL_TO_SUPPRESS = 'No email to suppress';

export type CrmSuppressionRow = Pick<OutreachRow, 'entryId' | 'email' | 'emailOverride' | 'suppressed' | 'suppressionId' | 'outreachState'>;

/** What the row menu offers: lift the row's own suppression, suppress its address, or explain why it can't. */
export type CrmSuppressionAction =
  | { kind: 'unsuppress'; suppressionId: number }
  | { kind: 'suppress'; address: string }
  | { kind: 'suppress_unavailable'; reason: string }
  | { kind: 'none' };

/** Mail goes to the campaign override when one is set, so that is the address to suppress. */
const sendingAddress = (row: CrmSuppressionRow): string | undefined => row.emailOverride || row.email || undefined;

/**
 * A suppression with no id of its own, and a thread an unsubscribe or a hard
 * bounce already stopped, are not changed from here: Settings › Suppressions
 * owns those.
 */
export function crmSuppressionAction(row: CrmSuppressionRow): CrmSuppressionAction {
  if (row.suppressed) {
    return row.suppressionId === undefined ? { kind: 'none' } : { kind: 'unsuppress', suppressionId: row.suppressionId };
  }
  if (isOutreachSuppressed(row.outreachState)) return { kind: 'none' };
  const address = sendingAddress(row);
  if (!address) return { kind: 'suppress_unavailable', reason: NO_EMAIL_TO_SUPPRESS };
  return { kind: 'suppress', address };
}
